import { graphqlClient } from './graphqlClient';

const MY_NOTIFICATIONS_QUERY = `
  query MyNotifications {
    myNotifications {
      id
      title
      message
      type
      isRead
      createdAt
    }
  }
`;

const MARK_READ_MUTATION = `
  mutation MarkNotificationRead($id: String!) {
    markNotificationRead(id: $id)
  }
`;

const REMOVE_MUTATION = `
  mutation RemoveNotification($id: String!) {
    removeNotification(id: $id)
  }
`;

/**
 * @returns {Promise<Array<{ id: string; title: string; message: string; type: string; isRead: boolean; createdAt: string }>>}
 */
export async function getMyNotifications() {
  const data = await graphqlClient.request(MY_NOTIFICATIONS_QUERY, {}, false);
  return data?.myNotifications ?? [];
}

/**
 * @param {string} id - Notification ID
 * @returns {Promise<boolean>}
 */
export async function markNotificationRead(id) {
  const data = await graphqlClient.request(MARK_READ_MUTATION, { id }, false);
  return data?.markNotificationRead ?? false;
}

/**
 * @param {string} id - Notification ID
 * @returns {Promise<boolean>}
 */
export async function removeNotification(id) {
  const data = await graphqlClient.request(REMOVE_MUTATION, { id }, false);
  return data?.removeNotification ?? false;
}
